const $ = window.jQuery;

const AnimateOnPageLinks = {
	init() {
		const $root = $('html, body');
		const offset = 50;

		const headerHeight = $('#header').outerHeight();

		$('a[href^="#"]:not(a[href="#form-standard"]):not(a[href="#form-onskemal"])').on('click', function () {
			const href = $.attr(this, 'href');

			$root.animate(
				{
					scrollTop: $(href).offset().top - offset - headerHeight,
				},
				500,
				function () {
					history.pushState(null, null, href);
				}
			);

			return false;
		});
	},
};

export default AnimateOnPageLinks;
